// react
import { useContext } from "react";

// components
import { Heading } from "../heading/Heading";
import { Copy } from "../copy/Copy";
import Shelf from "../shelf/shelf.component";
import Button from "../button/Button";
import FormControl from "../formControl/FormControl";

// context
import InitialContext from "../../context/InitialContext";

// styles
import "./signIn.styles.scss";

function SignIn(props: any) {
  // context
  const initialContext: any = useContext(InitialContext);

  const {
    initialState: {
      data: { BodyHeadline, UnAuthBodyCopy },
    },
  }: {
    initialState: {
      data: { BodyHeadline: string; UnAuthBodyCopy: string };
    };
  } = initialContext;

  function isElementVisible(element: Element) {
    const style = window.getComputedStyle(element);

    if (style.display == "none") {
      return false;
    } else {
      return true;
    }
  }
  function openSignInMenu() {
    const desktopStickyHeader = document.querySelectorAll(
      "#header-desktop .header-sticky-nav",
    );
    const mobileHeader = document.querySelectorAll("#header-mobile");

    // Mob/tab logic
    if (mobileHeader.length > 0 && isElementVisible(mobileHeader[0])) {
      const mobileNavSignIn = document.querySelectorAll(
        "#header-mobile .header-mobile-menu-bar .header-mobile-right-col .header-actions-container-desktop #NavigationActionSignIn #signin",
      );
      const signInMobile: HTMLElement = mobileNavSignIn[0] as HTMLElement;
      signInMobile.click();
    } else {
      // Desktop logic
      // Desktop sticky nav logic
      if (desktopStickyHeader.length > 0) {
        const stickyNavSignIn = document.querySelectorAll(
          "#header-desktop .header-sticky-nav #header-main-nav-container .fixed-header-actions-container.show-fixed-header-actions .header-actions-container-desktop #NavigationActionSignIn #signin",
        );
        const stickySignInDesktop: HTMLElement =
          stickyNavSignIn[0] as HTMLElement;
        stickySignInDesktop.click();
      } else {
        const nonStickyNavSignIn = document.querySelectorAll(
          "#header-desktop .header-utility-menu-desktop .header-actions-container-desktop #NavigationActionSignIn #signin",
        );
        const nonStickySignInDesktop: HTMLElement =
          nonStickyNavSignIn[0] as HTMLElement;
        nonStickySignInDesktop.click();
      }
    }
  }

  return (
    <>
      <div className="box">
        <Shelf mobile="15" tablet="10" desktop="10">
          <Heading className={"hdg hdg_h5 hdg_neutral"} element="h3" {...props}>
            {BodyHeadline}
          </Heading>
        </Shelf>

        <Shelf mobile="15" tablet="30" desktop="40">
          <Copy className={"copy"} {...props}>
            {UnAuthBodyCopy}
          </Copy>
        </Shelf>

        <div className="signIn-grid">
          <Shelf mobile="0" tablet="0" desktop="0">
            <div className="signInForm-buttonSpacer">
              <FormControl>
                <Button onClick={openSignInMenu}>Sign In</Button>
              </FormControl>
            </div>
          </Shelf>
        </div>
      </div>
    </>
  );
}

export default SignIn;
